import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
// import Cache from 'i18next-localstorage-cache'

i18n
  .use(XHR)
  // .use(Cache)
  // .use(LanguageDetector)
  .init({
    fallbackLng: 'en-GB',

    // have a common namespace used around the full app
    ns: [ 'common' ],
    defaultNS: 'common',
    debug: process.env.NODE_ENV === 'development',

    // cache: {
    //   enabled: true
    // },

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
      format: (value, format, lng) => {
        if (format === 'uppercase') return value.toUpperCase()
        return value
      }
    }
  })

export default i18n



// WEBPACK FOOTER //
// ./src/Utils/i18n.js